function initTheme() {

  // ============================================================
  // COUNTDOWN TIMER
  // ============================================================
  const timerEl = document.getElementById('countdown-timer');
  if (timerEl) {
    const targetDate = timerEl.dataset.target;
    const target = new Date(targetDate + 'T00:00:00');
    const daysEl = document.getElementById('days');
    const hoursEl = document.getElementById('hours');
    const minutesEl = document.getElementById('minutes');
    const secondsEl = document.getElementById('seconds');

    if (daysEl && hoursEl && minutesEl && secondsEl) {
      function updateCountdown() {
        const now = new Date();
        const diff = target - now;

        if (diff <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  }

  // ============================================================
  // FAQ ACCORDION
  // ============================================================
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    const btn = item.querySelector('.faq-item__question');
    if (!btn) return;
    btn.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      faqItems.forEach(function (i) {
        i.classList.remove('is-open');
        const b = i.querySelector('.faq-item__question');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ============================================================
  // MOBILE MENU
  // ============================================================
  function setMobileNavOpen(isOpen) {
    const mobileNav = document.getElementById('mobile-nav');
    const mobileToggle = document.getElementById('mobile-menu-toggle');
    if (!mobileNav || !mobileToggle) return;

    mobileNav.classList.toggle('is-open', isOpen);
    mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    mobileToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('mobile-nav-open', isOpen);
  }

  document.addEventListener('click', function (event) {
    const mobileToggle = event.target.closest('#mobile-menu-toggle');
    if (mobileToggle) {
      event.preventDefault();
      const mobileNav = document.getElementById('mobile-nav');
      if (!mobileNav) return;
      setMobileNavOpen(!mobileNav.classList.contains('is-open'));
      return;
    }

    const mobileNav = document.getElementById('mobile-nav');
    if (
      mobileNav &&
      mobileNav.classList.contains('is-open') &&
      !event.target.closest('#mobile-nav') &&
      !event.target.closest('#mobile-menu-toggle')
    ) {
      setMobileNavOpen(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setMobileNavOpen(false);
    }
  });

  const mobileNav = document.getElementById('mobile-nav');
  if (mobileNav) {
    mobileNav.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        setMobileNavOpen(false);
      }
    });
  }

  // ============================================================
  // STICKY HEADER SHADOW
  // ============================================================
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 4px 16px rgba(26,43,74,0.15)';
      } else {
        header.style.boxShadow = '0 2px 8px rgba(26,43,74,0.08)';
      }
    }, { passive: true });
  }

  // ============================================================
  // PRODUCT RESERVATION FORM
  // ============================================================
  document.querySelectorAll('.product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const teamField = form.querySelector('input[name="properties[Team Name]"]');

      if (teamField && !teamField.value.trim()) {
        e.preventDefault();
        alert('Please enter the Team Name.');
        teamField.focus();
        return false;
      }
    });
  });

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTheme);
} else {
  initTheme();
}
